const WRITE_PLACEHOLDER =
    'Try asking our AI something like ‘Pitch the importance of outbound sales to a business owner’';
const WRITE_BUTTON_TEXT = 'Write';
const EDIT_PLACEHOLDER =
    'Write an instruction to improve your message.\nExamples may include:\n- Writing in different languages\n- Writing for a different audience';
const EDIT_BUTTON_TEXT = 'Make Edits';

export { WRITE_PLACEHOLDER, WRITE_BUTTON_TEXT, EDIT_PLACEHOLDER, EDIT_BUTTON_TEXT };
